import { createContext, useContext } from "react";

export const LiveCountContext = createContext<number | null>(null);

/** Returns the live count of unique users currently on the site. */
export function useLiveUserCount(): number | null {
  return useContext(LiveCountContext);
}
